// Split out of AxisLineAnnotation.tsx (react-refresh/only-export-components)
// — a data constant + pure helper, not components. Behavior unchanged.
//
// ─── Stance Orientation Preset Library ──────────────────────────────────────
// Curated, pre-validated Stance Orientation configurations. Frontend-only
// constant — updates require a frontend deploy (acceptable for MVP, see
// backlog/stance-orientation-enhancement.md §Tier 2 open question 4).
// importance: 2=medium(33), 3=high(66), 4=critical(100) on AnnotationPanel scale.

export interface SOLibraryEntry {
  id: string;
  label: string;
  description: string;
  angle_tolerance_degrees: number;
  is_gate: boolean;
  /** 0–4 mapped to low/medium/high/critical (AnnotationPanel slider: 0/33/66/100). */
  importance: number;
}

export const SO_LIBRARY: SOLibraryEntry[] = [
  {
    id: 'side_profile_strict',
    label: 'Side Profile — Strict',
    description: 'Fencing, golf address. 15° tolerance, auto-fail gate.',
    angle_tolerance_degrees: 15,
    is_gate: true,
    importance: 4,
  },
  {
    id: 'side_profile_moderate',
    label: 'Side Profile — Moderate',
    description: 'Baseball, martial arts. 20° tolerance, auto-fail gate.',
    angle_tolerance_degrees: 20,
    is_gate: true,
    importance: 4,
  },
  {
    id: 'diagonal_soft',
    label: 'Diagonal — Soft',
    description: 'Tennis ready position. 25° tolerance, no gate.',
    angle_tolerance_degrees: 25,
    is_gate: false,
    importance: 3,
  },
  {
    id: 'frontal_bilateral',
    label: 'Frontal — Bilateral',
    description: 'Squat, deadlift. 30° tolerance, no gate.',
    angle_tolerance_degrees: 30,
    is_gate: false,
    importance: 2,
  },
];

/**
 * Map SO_LIBRARY's 0–4 importance scale to AnnotationPanel's 0–100 slider.
 * AnnotationPanel snap markers: 0=low, 33=medium, 66=high, 100=critical.
 */
export function soImportanceToSlider(imp: number): number {
  if (imp >= 4) return 100; // critical
  if (imp >= 3) return 66;  // high
  if (imp >= 2) return 33;  // medium
  return 0;                 // low
}
